import { render } from "./addreturn.vue?vue&type=template&id=728aad1d&scoped=true"
import script from "./addreturn.vue?vue&type=script&lang=js"
export * from "./addreturn.vue?vue&type=script&lang=js"

import "./addreturn.vue?vue&type=style&index=0&id=728aad1d&scoped=true&lang=css"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728aad1d"]])

export default __exports__